import type { Option } from "types";

export const industriesList: Option[] = [
  {
    value: "",
    title: "Enter Industry"
  },
  {
    value: "accounting",
    title: "Accounting"
  },
  {
    value: "banking and finance",
    title: "Banking and Finance"
  },
  {
    value: "entertainment",
    title: "Entertainment"
  },
  {
    value: "fitness and sport",
    title: "Fitness and Sport"
  },
  {
    value: "education",
    title: "Education"
  },
  {
    value: "information technology",
    title: "Information Technology"
  },
  {
    value: "fashion",
    title: "Fashion"
  },
  {
    value: "health care",
    title: "Health Care"
  },
  {
    value: "real estate",
    title: "Real Estate"
  }
];
